export default function AppShell() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-4">
      <div className="w-10 h-10 border-[3px] border-primary border-t-transparent rounded-full animate-spin" />
      <p className="text-sm font-bold text-muted-foreground tracking-widest uppercase">載入中...</p>
    </div>
  );
}
